const AppReducer = (state, action) => {
    switch (action.type) {
        case 'USER':
            return {
                ...state,
                user: action.user,
            };
        case 'BRAND':
            return {
                ...state,
                brand: action.brand,
            };
        case 'FINISHED_ONBOARDING':
            return {
                ...state,
                finishedOnboarding: action.finishedOnboarding,
            };
        case 'IS_SIDEBAR_OPEN':
            return {
                ...state,
                isSidebarOpen: action.isSidebarOpen,
            };
        default:
            return state;
    }
};

export default AppReducer;
